export enum Directions {
  Along = 'along',
  Against = 'against',
  Both = 'both',
}
